// extracted by mini-css-extract-plugin
module.exports = {"loader":"IsTyping_loader__orkvS","container":"IsTyping_container__Wj5GQ","circle":"IsTyping_circle__OGcZd","up":"IsTyping_up__2CmTw","down":"IsTyping_down__6OFsF"};